var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-spacer'),_c('v-col',[_c('Bonds')],1),_c('v-spacer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }